import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const TurkeyFlag = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 90 90"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#F31930"
      d="M87.429 30C81.254 12.534 64.611 0.015 45.034 0h-0.068C25.389 0.015 8.745 12.534 2.571 30C0.911 34.693 0 39.739 0 45c0 5.261 0.912 10.308 2.571 15C8.75 77.476 25.408 90 45 90s36.25-12.524 42.429-30C89.088 55.307 90 50.261 90 45C90 39.739 89.089 34.693 87.429 30z"
    />
    <path
      fill="#F3F4F5"
      d="M42.102 62.332c-9.739 0-17.634-7.76-17.634-17.333s7.895-17.333 17.634-17.333c5.241 0 9.934 2.26 13.164 5.828c-3.899-6.102-10.803-10.161-18.675-10.161c-12.174 0-22.042 9.7-22.042 21.667s9.868 21.667 22.042 21.667c7.875 0 14.781-4.062 18.679-10.168C52.041 60.07 47.346 62.332 42.102 62.332z"
    />
    <path
      fill="#F3F4F5"
      d="M62.926 34.878l-0.178 8.009l-7.472 2.029l7.366 2.623l-0.178 7.345l4.804-5.736l7.259 2.518l-4.199-6.155l5.124-6.121l-7.864 2.168L62.926 34.878z"
    />
  </svg>
);

const UKFlag = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 90 90"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#F3F4F5"
      d="M88.35 57.052c0.034-0.123 0.076-0.243 0.109-0.367l-0.004-0.002C89.457 52.957 90 49.043 90 45c0-4.033-0.54-7.938-1.538-11.657l0.004-0.002c-0.039-0.146-0.088-0.289-0.128-0.434c-0.137-0.492-0.28-0.982-0.434-1.468c-0.081-0.257-0.167-0.512-0.253-0.768c-0.073-0.217-0.139-0.437-0.215-0.653h-0.015c-1.645-4.653-4.021-8.96-7.01-12.768L59.997 27.458V2.57c-4.368-1.544-9.046-2.427-13.915-2.542h-2.164c-4.868 0.115-9.545 0.998-13.913 2.541v24.889L9.589 17.249c-2.989 3.809-5.366 8.116-7.01 12.769H2.564c-0.076 0.216-0.143 0.436-0.216 0.653c-0.086 0.255-0.172 0.509-0.253 0.765c-0.154 0.486-0.297 0.977-0.434 1.47c-0.04 0.145-0.089 0.287-0.128 0.432l0.004 0.002C0.54 37.061 0 40.966 0 45c0 4.043 0.543 7.957 1.545 11.684l-0.004 0.002c0.033 0.123 0.074 0.242 0.108 0.365c0.146 0.524 0.298 1.046 0.462 1.562c0.075 0.236 0.154 0.47 0.233 0.705c0.077 0.231 0.148 0.464 0.229 0.693H2.59c1.647 4.651 4.025 8.955 7.016 12.761l20.4-10.2v24.86C34.697 89.089 39.741 90 45 90c5.26 0 10.305-0.911 14.997-2.57V62.572l20.398 10.199c2.991-3.806 5.368-8.11 7.015-12.76h0.015c0.081-0.229 0.152-0.463 0.23-0.694c0.079-0.234 0.158-0.468 0.233-0.704C88.052 58.096 88.205 57.575 88.35 57.052z"
    />
    <path
      fill="#CC0000"
      d="M53.999 0.902c-2.565-0.521-5.213-0.81-7.917-0.874h-2.164c-2.703 0.064-5.35 0.354-7.914 0.874v35.116H0.899C0.311 38.92 0 41.924 0 45c0 3.087 0.312 6.1 0.904 9.012h35.1v35.087C38.911 89.689 41.919 90 45 90c3.082 0 6.091-0.311 8.999-0.902V54.012h35.097C89.688 51.1 90 48.087 90 45c0-3.076-0.311-6.08-0.899-8.983H53.999V0.902z"
    />
    <path
      fill="#CC0000"
      d="M85.242 65.135c0.829-1.653 1.56-3.363 2.184-5.125H74.993L85.242 65.135z"
    />
    <path
      fill="#CC0000"
      d="M82.216 19.701L61.581 30.019h13.412l10.261-5.131C84.353 23.088 83.341 21.354 82.216 19.701z"
    />
    <path
      fill="#CC0000"
      d="M4.747 24.887c-0.829 1.655-1.559 3.368-2.182 5.132H15.01L4.747 24.887z"
    />
    <path
      fill="#CC0000"
      d="M7.8 70.321L28.422 60.01H15.01L4.758 65.136C5.661 66.936 6.674 68.67 7.8 70.321z"
    />
    <path
      fill="#000066"
      d="M9.589 17.249l20.416 10.208v-3.99V2.584C21.874 5.458 14.813 10.593 9.589 17.249z"
    />
    <path
      fill="#000066"
      d="M59.997 2.585v22.302v2.57L80.411 17.25C75.188 10.594 68.128 5.459 59.997 2.585z"
    />
    <path
      fill="#000066"
      d="M30.006 72.77V62.572l-20.4 10.2c5.222 6.646 12.276 11.774 20.4 14.646V72.77z"
    />
    <path
      fill="#000066"
      d="M59.997 62.572v9.296v15.548c8.123-2.872 15.176-8 20.398-14.646L59.997 62.572z"
    />
  </svg>
);

const languages = [
  { code: "tr", name: "Türkçe", Flag: TurkeyFlag },
  { code: "en", name: "English", Flag: UKFlag },
];

const GuestLayout = () => {
  const { i18n } = useTranslation();

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem("language", languageCode);
  };

  const CurrentFlag = currentLanguage.Flag;

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center relative">
      {/* Language Switcher */}
      <div className="absolute top-4 right-4 flex items-center gap-2">
        <Link to="/">
          <Button variant="ghost" size="icon">
            <Home className="h-5 w-5" />
          </Button>
        </Link>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <CurrentFlag className="h-5 w-7 rounded-sm" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-40">
            {languages.map((language) => (
              <DropdownMenuItem
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`cursor-pointer ${
                  currentLanguage.code === language.code
                    ? "bg-primary/10 text-primary"
                    : ""
                }`}
              >
                <language.Flag className="h-4 w-6 mr-2 rounded-sm" />
                {language.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <Outlet />
    </div>
  );
};

export default GuestLayout;
